import { render, staticRenderFns } from "./recognizePhotoView.vue?vue&type=template&id=6d7a0499&scoped=true&"
import script from "./recognizePhotoView.vue?vue&type=script&lang=js&"
export * from "./recognizePhotoView.vue?vue&type=script&lang=js&"
import style0 from "./recognizePhotoView.vue?vue&type=style&index=0&id=6d7a0499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a0499",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\recognizePhotoPlugin\\recognize-photo-plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7a0499')) {
      api.createRecord('6d7a0499', component.options)
    } else {
      api.reload('6d7a0499', component.options)
    }
    module.hot.accept("./recognizePhotoView.vue?vue&type=template&id=6d7a0499&scoped=true&", function () {
      api.rerender('6d7a0499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recognizePhotoView.vue"
export default component.exports